export default __webpack_public_path__ + "static/media/7_map.4980ab80.png";